export default "__VITE_ASSET__9ef8ca8b__"